<template>
  <div>
    <!-- <el-row :gutter="5">
      <el-col :lg="8" :sm="10" :xs="24">
        <el-card>
          卡号:{{ cardInfo.cardId }} &nbsp;用户名:{{
            cardInfo.name === "0" ? "未绑定" : cardInfo.name
          }}({{ cardInfo.phone === "0" ? "未绑定" : cardInfo.phone }})
        </el-card>
      </el-col>

      <el-col :lg="6" :sm="7" :xs="24">
        <el-card v-if="cardInfo.memberType == 1 || cardInfo.memberType == 7">
          {{ cardInfo.memberType == 1 ? "微信" : "支付宝" }}：{{
            cardInfo.other.nickName
          }}({{ cardInfo.other.phone }})
        </el-card>
        <el-card v-else> 未绑定用户 </el-card>
      </el-col>
      <el-col :lg="6" :sm="6" :xs="12">
        <el-card v-if="cardInfo.memberCar">
          车辆:{{ cardInfo.memberCar.name }}({{ cardInfo.memberCar.shareCode }})
        </el-card>
        <el-card v-else> 未绑定车辆 </el-card>
      </el-col>

      <el-col :lg="4" :sm="4" :xs="12">
        <el-card :body-style="{ paddingTop: '0px', paddingBottom: '0px' }">
          <el-button style="margin: 10px 0" type="primary" @click="addMonth"
            >开通月卡</el-button
          >
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="5">
      <el-col :span="4" :xs="8">
        <el-card>
          <span>余额:{{ cardInfo.money }}</span>
        </el-card>
      </el-col>
      <el-col :span="4" :xs="8">
        <el-card>
          <span>累计:{{ cardInfo.grandTotalMoney }}</span>
        </el-card>
      </el-col>
      <el-col :span="4" :xs="8">
        <el-card> 豆币:{{ cardInfo.token }}</el-card>
      </el-col>
    </el-row> -->

    <el-row :gutter="10">
      <el-col :sm="12" :xs="24">
        <el-card>
          <div slot="header" style="color: #409eff">电卡信息：</div>
          <div class="card_wrapper card_optinos">
            <div class="card_main">
              <div>卡号：{{ cardInfo.cardId }}</div>
              <div>余额：{{ cardInfo.money }} 元</div>
            </div>
            <div class="card_main">
              <div>
                持卡人：
                {{
                  cardInfo.name === "0"
                    ? "未绑定"
                    : `${cardInfo.name}${
                        cardInfo.phone === "0" ? "" : "(" + cardInfo.phone + ")"
                      }`
                }}
              </div>
              <div>累计充值：{{ cardInfo.grandTotalMoney }} 元</div>
            </div>
            <div class="card_main">
              <div>
                车牌号：
                {{
                  cardInfo.memberCar ? cardInfo.memberCar.plateNumber : "未绑定"
                }}
              </div>
              <div>豆币：{{ cardInfo.token }} 元</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :sm="12" :xs="24" class="card_box">
        <el-card>
          <div slot="header" style="color: #409eff">电卡包月：</div>
          <div class="card_optinos card_main">
            <div class="card_wrapper">
              <div
                class="option_box"
                v-if="
                  cardInfo.memberCar && cardInfo.memberCar.carportMemberMonthly
                "
              >
                <div class="box_title">包月车库：</div>
                <div>{{ cardInfo.memberCar.carport.name }}</div>
              </div>

              <div class="option_box">
                <div class="box_title">代开充电包月：</div>
                <div>
                  <el-button class="box_button" type="primary" @click="addMonth"
                    >点击开通</el-button
                  >
                </div>
              </div>
            </div>

            <div class="card_wrapper" style="align-items: flex-end">
              <div class="box_title" v-if="cardInfo.memberMonthly">
                充电到期：{{
                  parseFormatDay(
                    new Date(cardInfo.memberMonthly.endTime * 1000)
                  )
                }}
              </div>
              <div class="box_title" v-if="cardInfo.memberMonthly">
                充电剩余时长：{{ cardInfo.memberMonthly.freeChargeNum }}
              </div>
              <div
                class="box_title"
                v-if="
                  cardInfo.memberCar && cardInfo.memberCar.carportMemberMonthly
                "
              >
                停车到期：{{
                  parseFormatDay(
                    new Date(
                      cardInfo.memberCar.carportMemberMonthly.endTime * 1000
                    )
                  )
                }}
              </div>
              <div>
                <el-button
                  v-if="
                    (cardInfo.memberCar &&
                      cardInfo.memberCar.carportMemberMonthly) ||
                    cardInfo.memberMonthly
                  "
                  class="box_button"
                  style="margin-top: 5px"
                  type="primary"
                  @click="handleEditMonthlyDate"
                  >修改包月信息</el-button
                >
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-tabs type="border-card">
      <el-tab-pane label="包月记录">
        <electricity-card-detail-four ref="monthlyRecordRef" />
      </el-tab-pane>
      <el-tab-pane label="充电记录">
        <electricity-card-detail-one />
      </el-tab-pane>
      <el-tab-pane label="充值记录">
        <electricity-card-detail-two />
      </el-tab-pane>
      <!-- <el-tab-pane label="已开通充电月卡">
        <electricity-card-detail-six />
      </el-tab-pane> -->

      <!-- <el-tab-pane label="充电包月记录">
        <electricity-card-detail-three/>
      </el-tab-pane>
      <el-tab-pane label="车库包月记录">
        <electricity-card-detail-four/>
      </el-tab-pane> -->
      <!--      <el-tab-pane label="转移记录">-->
      <!--        <electricity-card-detail-five/>-->
      <!--      </el-tab-pane>-->
    </el-tabs>

    <el-dialog
      width="20%"
      :visible.sync="editEndLineDialogState"
      title="修改包月信息"
      :fullscreen="isMobile"
    >
      <el-form
        ref="editMonthlyDateObj"
        :model="editMonthlyDateObj"
        label-width="auto"
        :rules="editMonthlyRules"
      >
        <el-form-item label="电卡卡号">
          <el-input v-model="cardInfo.cardId" readonly></el-input>
        </el-form-item>

        <el-form-item
          v-if="cardInfo.memberMonthly"
          label="充电剩余时长"
          prop="freeChargeNum"
        >
          <el-input
            v-model="editMonthlyDateObj.freeChargeNum"
            placeholder="请输入"
            type="number"
            min="0"
          >
          </el-input>
        </el-form-item>

        <el-form-item
          v-if="cardInfo.memberMonthly"
          label="充电到期时间"
          prop="chargeMonthlyDate"
        >
          <el-date-picker
            v-model="editMonthlyDateObj.chargeMonthlyDate"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            placeholder="请选择"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item
          v-if="cardInfo.memberCar && cardInfo.memberCar.carportMemberMonthly"
          label="停车到期时间"
          prop="carMonthlyDate"
        >
          <el-date-picker
            v-model="editMonthlyDateObj.carMonthlyDate"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            placeholder="请选择"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editEndLineDialogState = false">取消</el-button>
        <el-button type="primary" @click="handleEditMonthlyDateClick"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :fullscreen="dialogFullscreen"
      :visible.sync="monthDialog"
      title="代开充电包月"
      @close="handleOpenMonthDialogClose"
    >
      <el-form
        ref="params"
        :model="monthForm"
        :rules="rules"
        :validate-event="false"
        label-width="auto"
      >
        <!-- <el-form-item label="分组设备">
          <el-select
            v-model="id"
            :loading="loading"
            :remote-method="fetchDevice"
            filterable
            placeholder="请输入设备名"
            remote
            reserve-keyword
            @change="change"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="包月套餐" prop="monthlyInfoId">
          <el-select
            v-model="monthForm.monthlyInfoId"
            :disabled="checked"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in monthlyInfoList"
              :key="item.id"
              :label="
                item.startPower +
                '~' +
                item.endPower +
                'W' +
                '  ' +
                item.money +
                '元' +
                '\/' +
                item.freeDayNum +
                '天' +
                '\/' +
                item.freeChargeNum +
                '次'
              "
              :value="item.id"
            >
              <span>{{
                item.startPower +
                "~" +
                item.endPower +
                "W" +
                "  " +
                item.money +
                "元" +
                "\/" +
                item.freeDayNum +
                "天" +
                "\/" +
                item.freeChargeNum +
                "次"
              }}</span>
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="包月小区">
          <el-select
            v-model="id"
            :loading="loading"
            :remote-method="fetchGroup"
            filterable
            placeholder="请输入小区名称"
            remote
            reserve-keyword
            @change="handleDeviceGroupChange"
            ref="select"
            @focus="closeReadOnly"
            @hook:mounted="closeReadOnly"
            @visible-change="closeReadOnly"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.groupName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="包月套餐" prop="monthlyInfoId">
          <el-select
            v-model="monthForm.monthlyInfoId"
            :disabled="checked"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in monthlyInfoList"
              :key="item.id"
              :label="
                item.money +
                '元' +
                ' \/ ' +
                item.freeChargeNum +
                '小时，最大功率' +
                item.endPower +
                'W'
              "
              :value="item.id"
            >
              <span>{{
                item.money +
                "元" +
                " \/ " +
                item.freeChargeNum +
                "小时，最大功率" +
                item.endPower +
                "W"
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="包月数量">
          <el-input-number
            v-model="monthForm.openMonthNum"
            :min="1"
            :max="12"
          ></el-input-number>
          个月
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="monthDialog = false">取消</el-button>
        <el-button type="primary" @click="postData">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import agentEditMonthlyDate from "@/api/device/member-monthly-manage/agentEditMonthlyDate";
import agentOpenedAVipForWeChat from "@/api/device/member-monthly-manage/agentOpenedAVipForWeChat";
import ElectricityCardDetailOne from "@/views/ElectricityCardManage/ElectricityCardDetail/ElectricityCardDetailOne";
import ElectricityCardDetailTwo from "@/views/ElectricityCardManage/ElectricityCardDetail/ElectricityCardDetailTwo";
// import ElectricityCardDetailThree from "@/views/ElectricityCardManage/ElectricityCardDetail/ElectricityCardDetailThree";
import ElectricityCardDetailFour from "@/views/ElectricityCardManage/ElectricityCardDetail/ElectricityCardDetailFour";
// import ElectricityCardDetailSix from "@/views/ElectricityCardManage/ElectricityCardDetail/ElectricityCardDetailSix";
import agentGetOnlyChargeDeviceGroupIdNameList from "@/api/device/device-group-manage/agentGetOnlyChargeDeviceGroupIdNameList";
import getMonthlyByDeviceGroupId from "@/api/device/monthly-manage/getMonthlyByDeviceGroupId";
import getCardInfoByCardNumTop from "@/api/user/card-manage/getCardInfoByCardNumTop";
import createdMixin from "@/mixin/createMixin";
import dialogMixin from "@/mixin/dialogMixin";
import getAllDevice from "@/mixin/getAllDeviceMixin";
import isMobileMixin from "@/mixin/isMobileMixin";
import ResDispose from "@/mixin/resDisposeMixin";
import { Message } from "element-ui";

import timeMixin from "@/mixin/timeMixin";
export default {
  name: "ElectricityCardDetail",
  components: {
    ElectricityCardDetailTwo,
    ElectricityCardDetailOne,
    // ElectricityCardDetailThree,
    ElectricityCardDetailFour,
    // ElectricityCardDetailSix,
  },
  mixins: [
    createdMixin,
    dialogMixin,
    ResDispose,
    timeMixin,
    getAllDevice,
    isMobileMixin,
  ],
  data: () => ({
    monthDialog: false,
    cardInfo: {
      id: undefined,
      cardId: undefined,
      state: undefined,
      money: undefined,
      memberId: undefined,
      memberType: undefined,
      agentId: undefined,
      hasMonthly: undefined,
    },
    monthForm: {
      memberType: 3,
      memberId: undefined,
      monthlyInfoId: undefined,
      openMonthNum: 1,
    },
    deleteId: undefined,
    records: [
      {
        id: undefined,
        name: undefined,
      },
    ],
    rules: {
      monthlyInfoId: [{ required: true, message: "请选择包月套餐" }],
    },
    editMonthlyDateObj: {
      chargeMonthlyId: undefined,
      chargeMonthlyDate: undefined,
      carMonthlyId: undefined,
      carMonthlyDate: undefined,
      freeChargeNum: undefined,
    },
    editEndLineDialogState: false,
    editMonthlyRules: {
      chargeMonthlyDate: [
        {
          required: true,
          message: "请选择充电到期时间",
          trigger: ["blur", "change"],
        },
      ],
      carMonthlyDate: [
        {
          required: true,
          message: "请选择停车到期时间",
          trigger: ["blur", "change"],
        },
      ],
      freeChargeNum: [
        {
          required: true,
          message: "请输入充电剩余时长",
          trigger: ["blur", "change"],
        },
      ],
    },
  }),
  methods: {
    closeReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    handleDeviceGroupChange(val) {
      getMonthlyByDeviceGroupId(val).then((res) => {
        if (res.data.length === 0) {
          this.monthlyInfoList = [
            {
              id: null,
              freeDayNum: null,
              freeChargeNum: null,
              startPower: null,
              endPower: null,
              money: null,
            },
          ];
          this.monthForm.monthlyInfoId = undefined;
          this.checked = true;
        } else {
          this.monthlyInfoList = res.data;
          this.checked = false;
        }
      });
    },
    fetchGroup(query) {
      if (query !== "") {
        this.loading = true;
        agentGetOnlyChargeDeviceGroupIdNameList({ name: query }).then((res) => {
          this.options = res.data;
          this.loading = false;
        });
      } else {
        this.options = [];
      }
    },
    // 点击修改包月结束日期时触发
    handleEditMonthlyDate() {
      if (this.cardInfo.memberMonthly) {
        this.editMonthlyDateObj.chargeMonthlyId =
          this.cardInfo.memberMonthly.id;
        this.editMonthlyDateObj.chargeMonthlyDate =
          this.cardInfo.memberMonthly.endTime * 1000;
        this.editMonthlyDateObj.freeChargeNum = Math.max(
          this.cardInfo.memberMonthly.freeChargeNum,
          0
        );
      }
      if (
        this.cardInfo.memberCar &&
        this.cardInfo.memberCar.carportMemberMonthly
      ) {
        this.editMonthlyDateObj.carMonthlyId =
          this.cardInfo.memberCar.carportMemberMonthly.id;
        this.editMonthlyDateObj.carMonthlyDate =
          this.cardInfo.memberCar.carportMemberMonthly.endTime * 1000;
      }
      this.editEndLineDialogState = true;
    },
    // 点击修改包月日期确定按钮时触发
    handleEditMonthlyDateClick() {
      this.$refs["editMonthlyDateObj"].validate((valid) => {
        if (valid) {
          const DTO = { ...this.editMonthlyDateObj };
          // DTO.chargeMonthlyDate = DTO.chargeMonthlyDate / 1000;
          // DTO.carMonthlyDate = DTO.carMonthlyDate / 1000;
          DTO.chargeMonthlyDate = Math.floor(
            new Date(DTO.chargeMonthlyDate).setHours(23, 59, 59, 999) / 1000
          );
          DTO.carMonthlyDate = Math.floor(
            new Date(DTO.carMonthlyDate).setHours(23, 59, 59, 999) / 1000
          );
          agentEditMonthlyDate(DTO).then((res) => {
            if (res.code == 1) {
              Message.success(res.msg);
              this.editEndLineDialogState = false;
              this.fetchData();
            } else {
              Message.error(res.msg);
            }
          });
        }
      });
    },
    fetchData() {
      getCardInfoByCardNumTop(this.$route.query.id).then((res) => {
        this.cardInfo = res.data;
        // this.cardInfo.monthlyInfo = {
        //   endTime: Date.now(),
        // };
        // this.cardInfo.memberCar = {
        //   carport: { name: "牛马" },
        //   plateNumber: "川A51111",
        //   carportMemberMonthly: {
        //     endTime: Date.now(),
        //   },
        // };
        // console.log(this.cardInfo);
      });
    },
    addMonth() {
      if (this.cardInfo.state === "0") {
        return Message.error("请先将电卡绑定后再开通包月~");
      } else if (this.cardInfo.state === "-1") {
        return Message.error("电卡已禁用，无法开通包月~");
      } else if (this.cardInfo.state === "-2") {
        return Message.error("电卡已挂失，无法开通包月~");
      } else if (this.cardInfo.state === "-3") {
        return Message.error("电卡已更换，无法开通包月~");
      }

      this.monthDialog = true;
      this.fetchGroup();
    },
    postData() {
      this.$refs["params"].validate((valid) => {
        if (valid) {
          this.monthForm.memberId = this.$route.query.id;
          agentOpenedAVipForWeChat(this.monthForm).then((res) => {
            this.resDispose({
              res,
              success: () => {
                // 重新获取电卡包月记录
                if (this.$refs["monthlyRecordRef"]) {
                  this.$refs["monthlyRecordRef"].fetchData &&
                    this.$refs["monthlyRecordRef"].fetchData();
                }
                this.fetchData();
                this.monthDialog = false;
              },
            });
          });
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    handleOpenMonthDialogClose() {
      this.id = null;
      this.monthForm.monthlyInfoId = undefined;
      this.$nextTick(() => {
        this.$refs["params"].clearValidate("monthlyInfoId");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/styles/my";

@include mobile {
  .card_box {
    margin-top: 6px;
  }
  div.card_wrapper {
    display: block;
    .card_main {
      padding: 0;
      div {
        margin-bottom: 5px;
      }
    }
  }
  div.card_optinos {
    height: auto;
  }
  .card_optinos {
    .card_wrapper {
      div {
        margin-bottom: 5px !important;
      }
    }
  }
}

.card_main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 5px 0;
}
.card_wrapper {
  display: flex;
  justify-content: space-between;
}

.card_optinos {
  height: 80px;

  .option_box {
    display: flex;
    align-items: center;
  }
}

.box_button {
  padding: 10px 20px;
}

.el-row {
  margin: 10px 0;
}

.dredge {
  color: #528dcf;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.register {
  margin: 15px;
}

.their {
  margin-left: 30px;
}
</style>
